import { render } from "./B2bPageCommercialRelation.vue?vue&type=template&id=579a3efa&scoped=true&lang=pug"
import script from "./B2bPageCommercialRelation.vue?vue&type=script&lang=js"
export * from "./B2bPageCommercialRelation.vue?vue&type=script&lang=js"

import "./B2bPageCommercialRelation.vue?vue&type=style&index=0&id=579a3efa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579a3efa"]])

export default __exports__